import React from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';

import { getFirstInitial } from './avatar-service';

import './avatar.scss';
/**
 * This is an avatar used for indicating which user is logged in or which user the content refers to,
 * only the first letter of the name is used
 */
const Avatar = ({ className, name }) => (
    <div className={classnames(className, 'avatar', 'avatar--initial')}>
        {getFirstInitial(name)}
    </div>
);

Avatar.defaultProps = {
    className: undefined,
};

Avatar.propTypes = {
    className: string,
    /** The name of the user */
    name: string.isRequired,
};

export default Avatar;
